import { useState } from "react";
import api from "../../lib/api";
import { ageFromBirthDate } from "../../lib/format";
import { validateCodiceFiscale } from "../../lib/codiceFiscale";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { User } from "lucide-react";
import { SEZ, Field } from "./fields";

export const PatientSection = ({ patient, setPatient }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [show, setShow] = useState(false);

  const search = async (q) => {
    setQuery(q);
    if (!q.trim()) { setResults([]); setShow(false); return; }
    try { const { data } = await api.get("/patients", { params: { q } }); setResults(data); setShow(true); }
    catch { setResults([]); }
  };
  const select = (p) => {
    setPatient({ nominativo: p.nominativo || "", anni: p.anni || "", peso: p.peso || "", telefono: p.telefono || "", indirizzo: p.indirizzo || "", nato_a: p.nato_a || "", nato_il: p.nato_il || "", codice_fiscale: p.codice_fiscale || "", email: p.email || "" });
    setQuery(p.nominativo || ""); setShow(false);
  };
  const upd = (k) => (v) => setPatient({ ...patient, [k]: v });
  const onNatoIlChange = (v) => { const age = ageFromBirthDate(v); setPatient((p) => ({ ...p, nato_il: v, anni: age || p.anni })); };
  const cfCheck = validateCodiceFiscale(patient.codice_fiscale, patient.nominativo, patient.nato_il, patient.nato_a);
  const ageAuto = Boolean(patient.nato_il && ageFromBirthDate(patient.nato_il) && ageFromBirthDate(patient.nato_il) === patient.anni);

  return (
    <SEZ icon={User} title="Anagrafica Paziente (Dati Riservati)">
      <div className="md:col-span-2 relative">
        <Label className="nx-label">Richiama Paziente (cerca in anagrafica)</Label>
        <Input data-testid="patient-search" value={query} autoComplete="off" placeholder="Cerca per nominativo o telefono..."
          onChange={(e) => search(e.target.value)} onFocus={() => { if (results.length) setShow(true); }} className="mt-1.5" />
        {show && results.length > 0 && (
          <div className="absolute z-20 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-60 overflow-auto">
            {results.map((pp) => (
              <button type="button" key={pp.id} data-testid={`patient-option-${pp.id}`} onClick={() => select(pp)}
                className="w-full text-left px-3 py-2 hover:bg-slate-50 text-sm border-b border-slate-100 last:border-0">
                <span className="font-medium text-slate-800">{pp.nominativo}</span>
                <span className="text-slate-400"> · {pp.telefono || "—"} · {pp.trasporti} trasporti</span>
              </button>
            ))}
          </div>
        )}
      </div>
      <Field label="Nominativo" value={patient.nominativo} onChange={upd("nominativo")} testid="pat-nominativo" />
      <Field label={ageAuto ? "Anni (calcolati dalla data di nascita)" : "Anni"} type="number" value={patient.anni} onChange={upd("anni")} testid="pat-anni" placeholder="es. 72" />
      <Field label="Peso (kg)" value={patient.peso} onChange={upd("peso")} testid="pat-peso" />
      <Field label="Recapito Telefonico" value={patient.telefono} onChange={upd("telefono")} testid="pat-telefono" />
      <Field label="Indirizzo Email" type="email" value={patient.email} onChange={upd("email")} testid="pat-email" />
      <Field label="Indirizzo" value={patient.indirizzo} onChange={upd("indirizzo")} testid="pat-indirizzo" />
      <Field label="Nato a" value={patient.nato_a} onChange={upd("nato_a")} testid="pat-nato-a" />
      <Field label="Nato il" value={patient.nato_il} onChange={onNatoIlChange} testid="pat-nato-il" placeholder="gg/mm/aaaa" />
      <div>
        <Field label="Codice Fiscale" value={patient.codice_fiscale} onChange={upd("codice_fiscale")} testid="pat-cf" />
        {cfCheck && (
          <p data-testid="pat-cf-validation" className={`text-xs mt-1 ${cfCheck.level === "ok" ? "text-emerald-600" : cfCheck.level === "warn" ? "text-amber-600" : "text-red-600"}`}>
            {cfCheck.message}
          </p>
        )}
      </div>
    </SEZ>
  );
};
